import type { ApplicationContext } from '@hc-frontend/core-context';
import { createErrorOperationResult } from '@hc-frontend/core-utils-business-operation';

import { SubmitZipPlateTrackingOptions } from '../../entities/submit-zip-plate-tracking';
import type {
  SubmitZipPlateTrackingRepository,
  SubmitZipPlateTrackingResult,
} from '../../repositories/submit-zip-plate-tracking-repository';

export type TrackSubmitZipPlateUseCase = (
  options: SubmitZipPlateTrackingOptions,
) => Promise<SubmitZipPlateTrackingResult>;

export type TrackSubmitZipPlateParams = Pick<ApplicationContext, 'log'> &
  Pick<SubmitZipPlateTrackingRepository, 'trackSubmitZipPlate'>;

export function trackSubmitZipPlateFactory({
  trackSubmitZipPlate,
  log,
}: TrackSubmitZipPlateParams): TrackSubmitZipPlateUseCase {
  return async (options) => {
    const parsedOptions = SubmitZipPlateTrackingOptions.safeParse(options);
    if (!parsedOptions.success) {
      log({
        type: 'error',
        context: 'client',
        message: 'failedToTrackSubmitZipPlate',
        data: {
          rootCause: parsedOptions.error,
        },
      });

      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToTrackSubmitZipPlate',
            rootCause: parsedOptions.error,
          },
        ],
      });
    }

    const result = await trackSubmitZipPlate(options);
    if (!result.success) {
      log({
        type: 'error',
        context: 'client',
        message: result.errors[0].code,
        data: {
          rootCause: result.errors[0].rootCause,
        },
      });
    }

    return result;
  };
}
